import React from 'react';

const FiveHundredPXSvg = (props: any) => (
  <svg
    className="social-500px"
    viewBox="0 0 48 24"
    height="1em"
    width="1em"
    {...props}
  >
    <path d="M14.9 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10.7c-2.6 0-4.7-2.1-4.7-4.7s2.1-4.7 4.7-4.7 4.7 2.1 4.7 4.7-2.1 4.7-4.7 4.7zM27.8 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10.7c-2.6 0-4.7-2.1-4.7-4.7s2.1-4.7 4.7-4.7 4.7 2.1 4.7 4.7-2 4.7-4.7 4.7c.1 0 0 0 0 0zM4.6 9.6c-1.1-.2-2.3.1-3.2.8V7.3h5.4c.2 0 .3-.1.3-.6s-.2-.6-.4-.6H.8c-.3 0-.5.2-.5.5v5.3c0 .3.2.4.5.4.2.1.4 0 .5-.1.7-1 1.8-1.5 3-1.4 1.4.2 2.5 1.3 2.7 2.6.2 1.7-1 3.2-2.6 3.4H4c-1.3 0-2.4-.8-2.8-2-.1-.2-.2-.3-.7-.1s-.5.3-.5.5c.8 2.2 3.2 3.3 5.4 2.5 2.2-.8 3.3-3.2 2.5-5.4-.5-1.5-1.8-2.5-3.3-2.7zm33.3-3.5c-1.7.1-2.9 1.5-2.9 3.2v5.3c0 .3.2.4.6.4.4 0 .6-.1.6-.4V9.3c0-1 .7-1.9 1.7-2 .5-.1 1.1.1 1.5.5.4.4.7.9.7 1.4 0 .4-.2.8-.4 1.1-.4.5-1 .8-1.7.8-.2 0-.4 0-.5.5 0 .4 0 .5.3.6.6.1 1.2-.1 1.7-.4 1-.5 1.6-1.4 1.7-2.5.1-1.7-1.1-3.2-2.8-3.4h-.1c-.1.1-.3.2-.4.2zm7.8 3.1L47.9 7c.1 0 .2-.2-.1-.6-.1-.1-.3-.2-.4-.2-.1 0-.2 0-.2.1L45 8.4l-2.2-2.2c-.2-.2-.4-.1-.7.1s-.3.5-.1.7l2.2 2.2-2.2 2.1c-.1.1-.1.1-.1.2 0 .2.1.3.2.4.1.1.3.2.4.2.1 0 .2-.1.3-.1l2.2-2 2.2 2.2c.1.1.1.1.2.1.2 0 .3-.1.4-.2.2-.2.2-.5.1-.6l-2.2-2.3z" />
  </svg>
);

export default FiveHundredPXSvg;
